<template>
    <div class="o-announcementsList d-flex flex-column gap-1">
        <div
            class="col-12 d-flex d-lg-none align-items-center justify-content-end"
        >
            <the-btn
                text="Oznacz wszystkie jako przeczytane"
                class="btn-outline-custom"
                @click.native="$emit('markAllAnnouncementAsRead')"
            />
        </div>
        <announcement-preview
            v-for="el in list"
            :key="el.id"
            :announcement="el"
            :active-id="activeId"
            :show-options="true"
            :show-new-badge="true"
            :class="{ active: activeId === el.id }"
            @setActiveId="setAnnouncementActive"
        />
    </div>
</template>

<script>
import AnnouncementPreview from '@/components/announcements/AnnouncementPreview.vue'

export default {
    name: 'AnnouncementsList',
    data() {
        return {
            activeId: null
        }
    },
    components: {
        AnnouncementPreview
    },
    props: {
        list: {
            type: Array,
            required: true
        }
    },

    computed: {
        filters() {
            return this.$store.getters.getAnnouncementsFilters
        }
    },

    methods: {
        setAnnouncementActive(id) {
            if (!id) {
                this.activeId = null
                return
            }
            const aId = this.activeId
            this.activeId = id

            this.$nextTick(() => {
                if (aId && aId !== id) {
                    this.scrollToAnnouncement(id)
                }
                this.$store.dispatch('markAnnouncementAsRead', {
                    id,
                    unread: false
                })
            })
        },
        scrollToAnnouncement(id) {
            const el = document.querySelector(`#announcement-${id}`)
            if (el) {
                const headerHeight = document.querySelector('.site-header')
                    .clientHeight
                this.$scrollTo(el, 100, {
                    offset: -headerHeight - 16
                })
            }
        }
    },
    mounted() {
        this.activeId = +this.filters.id.value || +this.$route.query.id

        if (this.activeId) {
            this.scrollToAnnouncement(this.activeId)

            this.$store.dispatch('markAnnouncementAsRead', {
                id: this.activeId,
                unread: false
            })

            this.$nextTick(() => {
                const url = window.location.origin + window.location.pathname
                window.history.replaceState({}, document.title, url)
            })
        }
    }
}
</script>
